import React from 'react';
import { Trans } from 'react-i18next';

import {
    useTheme,
    Grid,
    Box,
    Typography,
} from '@mui/material';



export const DefinitionListItem = ({ term, definition, termWidth = 4, ...rest }) => {
    const theme = useTheme();

    const style = {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.tableSecondary,
        },
        padding: '4px',
        minHeight: (term == 'Description' || term == 'Description2' ? '56px' : 'unset'),
    };

    return (
        <Box sx={style} {...rest}>
            <Grid container spacing={1}>
                <Grid item xs={termWidth}>
                    <Typography component="dt" /*fontWeight="bold"*/ style={{fontSize: '14px'}}> 
                        <Trans>{term}</Trans>
                    </Typography>
                </Grid>
                <Grid item xs={12-termWidth}>
                    <Typography component="dd" title={definition} style={{fontSize: '14px'}}>
                        {definition}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

const DefinitionList = ({ data, list, ...rest }) => (
    <Box componet="dl" /*padding={1}*/ {...rest} >
        {list.map(item => {
            const definition = data ? `${data[item.key] || item.alt} ${item.append}` : '';

            return (
                <DefinitionListItem
                    key={item.key}
                    term={item.term}
                    definition={definition}
                />
            )
        })}
    </Box>
);

export default DefinitionList;
